import { useEffect, useState } from "react";

/**
 * Reactive mobile-breakpoint detector. Kanban and Calendar change their
 * structure (not just CSS) at ≤768px, so they need a JS signal — pure CSS
 * media queries can't drive the one-column carousel or the day-first
 * calendar default. Article-view changes stay pure CSS and don't use this.
 */
export function useIsMobile(bp = 768): boolean {
  const [mobile, setMobile] = useState(
    typeof window !== "undefined" &&
      window.matchMedia(`(max-width:${bp}px)`).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width:${bp}px)`);
    const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
    setMobile(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [bp]);

  return mobile;
}
